module.exports = __webpack_public_path__ + "static/google-play-badge-en-63ca526f8dcf281f6a6f0a8ed639463f.png";